module.exports = __webpack_public_path__ + "static/img/OSC_Dokumente.91f3dfa9.svg";